export default "__VITE_ASSET__Bu7GSBG5__"